<template>
  <!-- 意向登记管理页面 -->
  <div class="page-container">
    <div class="page-card">
      <!-- 页面头部 -->
      <div class="page-card__header">
        <span style="padding-right: 20px"> 意向登记（共{{aSum}}人）</span>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="coname"
            label="申请参展公司名称"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="联系人"
            width="80"
          >
          </el-table-column>

          <el-table-column
            prop="position"
            label="职务"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号码"
          >
          </el-table-column>
          <el-table-column
            prop="email"
            label="邮箱">
          </el-table-column>
          <el-table-column
            prop="area"
            label="面积"
            width="80">
          </el-table-column>

          <el-table-column
            prop="type"
            label="类型"
            width="80">
          </el-table-column>

          <el-table-column
            prop="remarks"
            label="留言" width="80">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="申请日期">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn--danger"
                @click="deleteInfo(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <div style="margin: 20px 0; padding: 20px 0; text-align: center">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {

    data() {
      return {
        changetype: true,
        changeID: 0,
        tableData: [],
        // 分页相关数据
        aSum: 0,
        currentPage: 1,
        pageCount: 1,
        pagesize: 10,
      }
    },
    components: {
    },
    mounted() {
      // 初始化加载数据
      this.getinfo();
    },
    methods: {
      // 获取意向登记列表数据
      getinfo() {
        let url = this.baseUrl + "/admin/applys/?ordering=-create_time";
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        })
      },

      // 分页切换处理
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/applys/?ordering=-create_time&page=" + val;
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      // 删除意向登记信息
      deleteInfo(row) {
        this.$confirm('将删除此条信息，是否继续', '提示', {
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: "warning"
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/applys/" + id + "/";
          api.deleteData(url).then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getinfo();
          })
        })
      },

      // 切换到详情视图
      changePage() {
        this.changetype = true;
      },

      // 切换到列表视图
      changePage_hit() {
        this.changetype = false;
      },

      // 跳转到展商详情页
      handleClick() {
        this.$router.push({name: 'admin_exhibitorDetails'})
      },
    },
  }
</script>

<style scoped>
  .changtype {
    background-color: var(--color-primary);
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/accountManage.vue